import { KameleoonGoal } from './kameleoonGoals';
import { useCallback } from 'react';

type UseTrackConversionParams = {
    goal: KameleoonGoal;
};

/**
 * Type definition for the return value of useTrackConversion
 * @see {useTrackConversion}
 */
/** Callback function used to fire the tracking event - bidAmount should be passed in for goals where bids are being tracked*/
type UseTrackConversionReturn = (bidAmount?: number) => void;

/**
 * useTrackConvsersion -  returns a function to track conversion for Kameleoon experiments
 *
 * @see https://developers.kameleoon.com/feature-management-and-experimentation/web-sdks/js-sdk/#trackconversion
 *
 * @param goal - Kameleoon Goal to be tracked
 * @see {KameleoonGoal}
 * @returns {UseTrackConversionReturn}
 * @deprecated This hook is deprecated. Use Amplitude goals instead of Kameleoon tracking.
 */
export const useTrackConversion = ({ goal }: UseTrackConversionParams): UseTrackConversionReturn => {
    /**
     * @deprecated This hook is deprecated. Use Amplitude goals instead of Kameleoon tracking.
     */
    const trackConversion = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        (bidAmount?: number) => {
            if (process.env.NODE_ENV === 'development') {
                console.warn(
                    '[DEPRECATED] useTrackConversion is deprecated. Please convert to using Amplitude goals instead of Kameleoon tracking for goal:',
                    goal.goalName
                );
                return;
            }
        },
        [goal.goalName]
    );

    return trackConversion;
};
